import { Link, Text } from '@ardoq/typography';
import { currentYear } from '@ardoq/date-time';
import { type I18nLocale, t } from '@ardoq/i18n';

type FooterLinkProps = {
  label: string;
  href: string;
};

const FooterLink = ({ label, href }: FooterLinkProps) => (
  <Link hideIcon typography="text2" underlineOnHover href={href}>
    {label}
  </Link>
);

type CopyrightFooterProps = {
  i18nLocale?: I18nLocale;
};

export const CopyrightFooter = ({ i18nLocale = {} }: CopyrightFooterProps) => (
  <Text color="textSubtle">
    2013-{currentYear()} © Ardoq AS, All Rights Reserved.{' '}
    <FooterLink
      label={t(
        i18nLocale,
        'snowflakes:copyrightFooter.privacyNotice',
        'Privacy Notice'
      )}
      href="https://ardoq.com/privacy/"
    />{' '}
    |{' '}
    <FooterLink
      label={t(
        i18nLocale,
        'snowflakes:copyrightFooter.termsOfService',
        'Terms of Service'
      )}
      href={'https://ardoq.com/terms/'}
    />
  </Text>
);
